import { API_APP_ID, API_PATHS, buildApiUrl } from "../../config";
import { createApiClient } from "./createApiClient";

/**
 * Unauthenticated CRM auth API (Keycloak player login).
 * Base: {API_BASE_URL}api/v1/auth/
 */
const authClient = createApiClient({
  baseURL: buildApiUrl(API_PATHS.AUTH),
  headers: {
    "X-App-Id": API_APP_ID,
  },
});

export default authClient;
